import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { IpService } from '../shared/ip/ip.service';

@Injectable({
  providedIn: "root"
})

export class GeneralMethods {

  constructor(
    private translate: TranslateService,
    private ipService: IpService
  ) { }

  async getHeader(isJson: boolean = true) {
    let token = sessionStorage.getItem('jwt');
    let publicIp = await this.ipService.getPublicIp();
    let localIp = await this.ipService.getLocalIp();
    if(isJson){
      return new HttpHeaders({
        "Authorization": "Bearer " + token,
        "Content-Type": "application/json",
        "PublicIp": publicIp,
        "LocalIp": localIp
      })
    }
    else{
      return new HttpHeaders({
        "Authorization": "Bearer " + token,
        "PublicIp": publicIp,
        "LocalIp": localIp
      })
    } 
  }

  async getHeaderWithoutToken() {
    let publicIp = await this.ipService.getPublicIp();
    let localIp = await this.ipService.getLocalIp();
    return new HttpHeaders({
      "Content-Type": "application/json",
      "PublicIp": publicIp,
      "LocalIp": localIp
    })
  }

  setLanguage(lang: string) {
    this.translate.use(lang);
  }
}
